module.exports = __webpack_public_path__ + "img/change.069d809f.svg";